import { SET_SHOWS, ShowActionTypes, ShowState } from "./types";

export function setShows(shows: ShowState): ShowActionTypes {
    return {
        type: SET_SHOWS,
        payload: shows,
    };
}
